import React, { useEffect } from 'react';
import {observer} from 'mobx-react-lite';
import ApplicationLayout from '@rio-cloud/rio-uikit/lib/es/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/lib/es/NotificationsContainer';
import FotaHeader from '@components/Navbar/Navbar';
import FotaSidebar from '@components/Sidebar/Sidebar.jsx';
import ServiceMenuDialog from '@components/Dialogs/SupportMenu/ServiceMenuDialog';
import { useStores } from '@stores/context.jsx';
import AnalyticsKPIs from "./AnalyticsKPIs.jsx";

export default observer(() => {
    const { serviceStore } = useStores();

    useEffect(() => {
        serviceStore
    }, [serviceStore])

    return (
        <ApplicationLayout className={'MyServiceLayout'}>
            <ApplicationLayout.Header>
                <FotaHeader />
            </ApplicationLayout.Header>
            <ApplicationLayout.Sidebar className='bg-muted'>
                <FotaSidebar />
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Body className='responsive'>
                <NotificationsContainer />
                {serviceStore.serviceMenuDialogOpen &&
                    <ServiceMenuDialog/>
                }
                <AnalyticsKPIs />
            </ApplicationLayout.Body>
        </ApplicationLayout>
    );
});
